import { useState, useEffect, useRef } from "react"
import {
  Table,
  Header,
  HeaderRow,
  Body,
  Row,
  HeaderCell,
  Cell,
  Footer,
  FooterRow,
  FooterCell,
} from "@table-library/react-table-library/table"
import RightArrow from "../../assets/icons/rightarrow.svg"
import LeftArrow from "../../assets/icons/lefarrow.svg"
import redLeftArrow from "../../assets/icons/redLeftArrow.svg"
import plusIcon from "../../assets/icons/plusIcon.svg"
import minusIcon from "../../assets/icons/minusIcon.svg"
import sort_arrows from "../../assets/icons/sort_arrows.svg"
import disabledRightArrow from "../../assets/icons/disabledRightArrow.svg"
import {
  useSort,
  HeaderCellSort,
} from "@table-library/react-table-library/sort"
import { usePagination } from "@table-library/react-table-library/pagination"
import { useTheme } from "@table-library/react-table-library/theme"
import { UncontrolledPopover } from "reactstrap"
import Select from 'react-select'

import {
  HeaderCellSelect,
  CellSelect,
  SelectClickTypes,
  SelectTypes,
  useRowSelect,
} from "@table-library/react-table-library/select"
import { use } from "react"

const UpdateTable = ({
  nodes,
  paginate,
  columns,
  handlePagination,
  handleSizePerPage,
  tableWidth,
  expand,
  subColumn,
  anotherSubColumn,
  subName,
  anotherSubName,
  subHeader,
  CurrentPage,
  checkbox = false,
  handilpagedrop = true,
  headerHide,
  noShowCount,
  mobileWidth,
  showFooter,
  allExpand,
  hidePaginate = false,
  isLoading = false,
}) => {
  const values = { nodes }

  const INITIAL_PARAMS = {
    search: "",
    filter: false,
    page: 1,
  }

  const theme = useTheme({
    Table: `
      --data-table-library_grid-template-columns: ${window.innerWidth < 850 ? mobileWidth : tableWidth
      };
    `,
    Row: `
      &.table_row:hover {
        background-color: #f5f5f5 !important;
      }
      .sub-table-row .sub-hover:hover .td {
      background-color: #f5f5f5 !important;
    }
    .another-sub-table-row sub-hover:hover .td {
      background-color: #f5f5f5 !important;
    }
    `,
  });

  const countsPerPage = [2, 3, 5, 7, 8, 9]

  const [data, setData] = useState({
    nodes: [],
    from: 0,
    to: 0,
    cur_page: 1,
    totalPages: 0,
    per_page: 0,
    count: 0,
  })
  const [dataPerPage, setDataPerPage] = useState(data.per_page)
  const [handleSizePerPageState, setHandleSizePerPageState] = useState([25, 50, 75, 100, 500, 1000])
  const [limit, setLimit] = useState(handleSizePerPageState)

  useEffect(() => {
    setLimit(handleSizePerPageState)
  }, [handleSizePerPageState])

  const handleChange = event => {
    pagination.fns.onSetPage(event.target.value)
  }
  const handlePerPageChange = event => {
    setDataPerPage(event.target.value)
    handleSizePerPage(event.target.value)
  }

  // For Dynamic sorting
  const generateSortFns = columns => {
    const sortFns = {}
    columns.forEach(column => {
      const { label, sortKey } = column
      sortFns[label] = array => {
        if (typeof sortKey === "string") {
          return array.sort((a, b) => a[sortKey]?.localeCompare(b[sortKey]))
        } else if (typeof sortKey === "function") {
          return array.sort(sortKey)
        }
        return array
      }
    })
    return sortFns
  }

  const sort = useSort(
    values,
    {
      onChange: onSortChange,
    },
    {
      sortIcon: {
        // position: SortIconPositions.Prefix, //if we need to bring the sort icon front
        size: "12px",
        iconDefault: <img src={sort_arrows} alt="DEFAULT_IMG" />,
        iconUp: <img src={sort_arrows} alt="UP_IMG" />,
        iconDown: <img src={sort_arrows} alt="DOWN_IMG" />,
      },
      sortFns: generateSortFns(columns),
    }
  )

  function onSortChange(action, state) {
    console.log(action, state)
  }

  // For Pagination
  const pagination = usePagination(
    data,
    {
      state: {
        page: INITIAL_PARAMS.page,
      },
      onChange: onPaginationChange,
    },
    {
      isServer: true,
    }
  )

  useEffect(() => {
    setData({
      nodes: [],
      from: paginate?.from ? paginate?.from : 0,
      to: paginate?.to ? paginate?.to : 0,
      cur_page: paginate?.current_page ? paginate?.current_page : 0,
      totalPages: paginate?.last_page ? paginate?.last_page : paginate?.lastPage ? paginate?.lastPage : 0,
      per_page: paginate?.per_page ? paginate?.per_page : 0,
      count: paginate?.total ? paginate?.total : 0,
    })
  }, [paginate])
  useEffect(() => {
    if (CurrentPage) {
      pagination.fns.onSetPage(CurrentPage)
      setData({
        nodes: [],
        from: paginate?.from ? paginate?.from : 0,
        to: paginate?.to ? paginate?.to : 0,
        cur_page: CurrentPage ? CurrentPage : paginate?.current_page,
        totalPages: paginate?.last_page ? paginate?.last_page : paginate?.lastPage ? paginate?.lastPage : 0,
        per_page: paginate?.per_page ? paginate?.per_page : 0,
        count: paginate?.total ? paginate?.total : 0,
      })
    }
  }, [CurrentPage])

  function onPaginationChange(action, state) {
    handlePagination(action?.payload?.page)
  }

  const renderPagination = () => {
    const pagesToShow = []

    if (data?.totalPages < 7) {
      for (let i = 1; i <= data?.totalPages; i++) {
        pagesToShow.push(i)
      }
    } else {
      if (
        pagination.state.page % 5 >= 0 &&
        pagination.state.page > 4 &&
        pagination.state.page + 2 < data?.totalPages
      ) {
        pagesToShow.push(
          1,
          pagination.state.page - 1,
          pagination.state.page,
          pagination.state.page + 1,
          data?.totalPages
        )
      } else if (
        pagination.state.page % 5 >= 0 &&
        pagination.state.page > 4 &&
        pagination.state.page + 2 >= data?.totalPages
      ) {
        pagesToShow.push(
          1,
          data?.totalPages - 3,
          data?.totalPages - 2,
          data?.totalPages - 1,
          data?.totalPages
        )
      } else {
        pagesToShow.push(1, 2, 3, 4, 5, data?.totalPages)
      }
    }
    return (
      <span>
        {pagesToShow.map((page, index) => (
          <span key={index} onClick={() => pagination.fns.onSetPage(page)}>
            {pagesToShow[index - 1] + 2 < page ? (
              <span>
                <button
                  className={`${pagination.state.page === page ? "active" : ""
                    }`}
                >
                  ...
                </button>
                <button
                  className={`${pagination.state.page === page ? "active" : ""
                    }`}
                >
                  {page}
                </button>
              </span>
            ) : (
              <button
                className={`${pagination.state.page === page ? "active" : ""}`}
              >
                {page}
              </button>
            )}
          </span>
        ))}
      </span>
    )
  }

  const [ids, setIds] = useState()
  const [subIds, setSubIds] = useState()

  useEffect(() => {
    if (allExpand && nodes?.length > 0) {
      // Set all items as expanded when allExpand is true
      console.log("hiii", nodes)
      setIds(nodes.map(item => item.id))
    } else {
      // Reset to empty array when allExpand is false
      setIds([])
    }
  }, [allExpand, nodes])


  const handleExpand = item => {
    if (ids?.id == item.id) {
      setIds()
      setSubIds()
    } else {
      setIds(item)
      setSubIds()
    }
  }

  const handleSubExpand = item => {
    if (subIds?.id == item.id) {
      setSubIds()
    } else {
      setSubIds(item)
    }
  }

  const onSelectChange = (action, state) => {
    console.log("onSelect change", action, state)
  }

  const select = useRowSelect(data, {
    onChange: onSelectChange,
  })

  // const hoverDataRef = useRef(null)

  // useEffect(() => {
  //   if (hoverDataRef.current) {
  //     const idValue = hoverDataRef.current.getAttribute("id")
  //     console.log("idValue ::", idValue) // Log the value of the id attribute
  //   }
  // }, [hoverDataRef.current])

  console.log("loader", isLoading);

  return (
    <>
      <div className="h-100 d-flex flex-column justify-content-between">
        <Table
          data={values}
          sort={sort}
          theme={theme}
          select={checkbox && select}
          layout={{ custom: true, horizontalScroll: true }}
          className="mt-0 for-scroll"
        >
          {tableList => (
            <>
              {headerHide  ? (
                <></>
              ) : (
                <Header>
                  <HeaderRow>
                    {checkbox && <HeaderCellSelect />}
                    {columns.map((column, index) => (
                      <>
                        {column?.sortKey ? (
                          <HeaderCellSort
                            sortKey={column?.label}
                            className="h-50"
                            style={{ background: "#F7F7F7" }}
                          >
                            {column.label}
                          </HeaderCellSort>
                        ) : (
                          <HeaderCell key={index} className="h-100" style={{ background: "#F7F7F7" }}>
                            {column.checkedHead
                              ? column.headerCell(tableList)
                              : column.label}
                          </HeaderCell>
                        )}
                      </>
                    ))}
                  </HeaderRow>
                </Header>
              )}

              <Body>
                {tableList?.length > 0 ? (
                  tableList.map(item => (
                    <>
                      <Row key={item.id} item={item} className="table_row">
                        {checkbox && <CellSelect item={item} />}

                        {columns.map((column, index) => (
                          <Cell
                            key={index}
                            className={`font-16 ${item?.[subName]?.length && "cursor-pointer"
                              } `}
                            onClick={() =>
                              expand && index == 0 && handleExpand(item)
                            }
                          >
                            <div
                              className={`${expand &&
                                index == 0 &&
                                item?.[subName]?.length ? "d-flex align-items-center" : ""}`}
                            // className="hover-data"
                            // id={`Popover-${item?.id}`}
                            // ref={hoverDataRef}
                            >
                              {expand &&
                                index == 0 &&
                                item?.[subName]?.length ? (
                                <img
                                  src={ids?.id == item.id ? minusIcon : plusIcon}
                                  className="plus-wdt me-1"
                                />
                              ) : (
                                <></>
                              )}
                              {column.renderCell(item)}
                            </div>
                            {/* <UncontrolledPopover
                              placement="bottom"
                              target={`Popover-${item?.id}`}
                              trigger="hover"
                            >
                              <div className="table-popup-content">
                                {"data is comming"}
                              </div>
                            </UncontrolledPopover> */}
                          </Cell>
                        ))}
                      </Row>
                      <>
                        {(allExpand == true
                          ? ids.some(num => num == item?.id)
                          : ids?.id == item.id) && item?.[subName]?.length ? (
                          <Row key={item.id} item={item} className="table_row ">
                            <span className="sub-table-row">
                              <div className="d-flex">
                                {subHeader &&
                                  subColumn.map((column, index) => (
                                    <HeaderCell
                                      key={index}
                                      className="h-100 sub-header w-20"
                                    >
                                      {column.label}
                                    </HeaderCell>
                                  ))}
                              </div>
                              {item?.[subName]?.map(subItem => (
                                <>
                                  <div className="d-flex sub-hover">
                                    {subColumn?.map((column, index) => (
                                      <>
                                        <Cell
                                          key={index}
                                          className={`font-16 ever-rise-subTable w-20 ${item?.[subName]?.length &&
                                            "cursor-pointer"
                                            } `}
                                          onClick={() =>
                                            expand &&
                                            index == 0 &&
                                            handleSubExpand(subItem)
                                          }
                                        >
                                          {column.renderCell(subItem)}
                                        </Cell>
                                      </>
                                    ))}
                                  </div>
                                  <div>
                                    {ids?.id == item.id &&
                                      subIds?.id == subItem?.id &&
                                      anotherSubName?.length ? (
                                      <div
                                        key={item.id}
                                        item={item}
                                        className="table_row another_sub_table_row"
                                      >
                                        <span className="another-sub-table-row ">
                                          <div className="d-flex">
                                            {subHeader &&
                                              anotherSubColumn.map(
                                                (column, index) => (
                                                  <HeaderCell
                                                    key={index}
                                                    className="h-100 another-sub-header w-50"
                                                  >
                                                    {column.label}
                                                  </HeaderCell>
                                                )
                                              )}
                                          </div>
                                          <div className="d-flex sub-hover">
                                            {anotherSubColumn?.map(
                                              (column, index) => (
                                                <Cell
                                                  key={index}
                                                  className="font-16 ever-rise-next-subTable w-50"
                                                >
                                                  {column.renderCell(subIds)}
                                                </Cell>
                                              )
                                            )}
                                          </div>
                                        </span>
                                      </div>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                </>
                              ))}
                            </span>
                          </Row>
                        ) : (
                          <></>
                        )}
                      </>
                    </>
                  ))
                ) : (
                  <Row>
                    <Cell className="font-16 table-no-data ">
                      <div className="d-flex justify-content-center">
                        No Data Found
                      </div>
                    </Cell>
                  </Row>
                )}
                {isLoading ? (
                  // <div className="loader-row">
                    <Row>
                    <Cell className="font-16 table-no-data ">
                    <div className={`bouncing-loader`}>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                    </Cell>
                    </Row>
                  // </div>
                ) : (paginate?.last_page > 0 && nodes?.length != 0) ? (
                  <Row>
                    <Cell className="font-16 table-no-data ">
                      <div className="d-flex justify-content-center">
                        End of List
                      </div>
                    </Cell>
                  </Row>
                ) : (
                  <></>
                )}
              </Body>
              {showFooter && (
                // <Footer>
                //   <Row>
                //     {columns.map((column, index) => (
                //       <Cell key={index} className="font-16 footer-cell">
                //         {/* Example: Show totals or summaries */}
                //         {column.footerContent
                //           ? column.footerContent(data.nodes)
                //           : null}
                //       </Cell>
                //     ))}
                //   </Row>
                // </Footer>

                <Footer>
                  <FooterRow>
                    {columns.map((column, index) => (
                      <FooterCell key={`footer${index}`}>
                        {column?.footerContent &&
                          typeof column.footerContent === "function"
                          ? column.footerContent(data)
                          : null}
                      </FooterCell>
                    ))}
                  </FooterRow>
                </Footer>
              )}
            </>
          )}
        </Table>

        {data?.totalPages && paginate?.last_page > 1 && !hidePaginate ? (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            className="my-2 pagination-details"
          >
            {noShowCount || (paginate?.from == null && paginate?.to == null) ? (
              <div></div>
            ) : (
              <div className="d-flex column-gap-4">
                {handilpagedrop && (
                  <div className="select-items-per-page">
                    <select
                      id="select-items-per-page"
                      data-testid="select-items-per-page"
                      name="items per page"
                      aria-label="items per page"
                      className="custome-select-page"
                      value={limit}
                      onChange={(e) => {
                        setLimit(e.target.value)
                        handlePerPageChange(e)
                      }}
                    >
                      {handleSizePerPageState.map(count => (
                        <option key={count} value={count}>
                          {count}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
                <div className="showing-page">
                  Showing {paginate?.from}-{paginate?.to} from {paginate?.total}
                </div>
              </div>
            )}
            <div>
              <button
                type="button"
                className="left-pagination-button"
                disabled={data.cur_page === 1}
                onClick={() => pagination.fns.onSetPage(data.cur_page - 1)}
              >
                <img
                  src={data.cur_page === 1 ? LeftArrow : redLeftArrow}
                  alt="Left Arrow"
                />{" "}
                {noShowCount ? "" : "Back"}
              </button>

              <span>{renderPagination()}</span>
              <button
                type="button"
                className="right-pagination-button"
                disabled={data.cur_page === data.totalPages}
                onClick={() => pagination.fns.onSetPage(data.cur_page + 1)}
              >
                {noShowCount ? "" : `Next  `}
                <img
                  src={
                    data.cur_page === data.totalPages
                      ? disabledRightArrow
                      : RightArrow
                  }
                  alt="right Arrow"
                />
              </button>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  )
}
export default UpdateTable
